<div class="search-input" [class.search-input--clear]="model" [class.search-input--loading]="loading">
  <input
    #myinput
    type="text"
    [(ngModel)]="model"
    (ngModelChange)="modelChange.emit(model)"
    (keyup.enter)="enter.emit()"
    [placeholder]="placeholder"
    [autocomplete]="false"
    />
  @if (!loading) {
    <i class="im-icon im-icon-x-round-filled" (click)="clear.emit()"></i>
  }
  @if (loading) {
    <app-inline-spinner></app-inline-spinner>
  }
</div>
